import React from 'react';
import { RussianGgLogo, SevilLogo } from '../components/ProductLogos';
import type { Dict } from '../lib/locales/en';

export type ProductStatus = 'live' | 'beta' | 'soon';

/** Ties a product to its copy: adding a product without translating it is a
 *  compile error rather than a blank card. */
export type ProductId = keyof Dict['product'];

export interface Product {
  id: ProductId;
  /** A brand name, so it is the same in every language and never translated. */
  name: string;
  status: ProductStatus;
  /** The year the product launched, shown on the tile. */
  since: string;
  url?: string;
  Logo: React.ComponentType<{ size?: number }>;
}

/** The Vaqtly Holding product line. Both startups launched in 2026. */
export const products: Product[] = [
  {
    id: 'russian-gg',
    name: 'russian.gg',
    status: 'live',
    since: '2026',
    url: 'https://russian.gg',
    Logo: RussianGgLogo,
  },
  {
    id: 'sevil',
    /* The product goes by its domain, the same way russian.gg does. The mark
       still reads "sevil." — that is the logotype, not the name. */
    name: 'sevil.app',
    status: 'live',
    since: '2026',
    url: 'https://sevil.app',
    Logo: SevilLogo,
  },
];
